import { useCallback } from 'react'
import { useGetAppLink } from '../useGetAppLink'
import { Application, EntryPoint } from '@wellesley/openapi'
import { usePersonalAppsList } from '../usePersonalAppsList'
import { useLazyGetApiV1GroupsByGroupIdAppsQuery } from '../../appsApi'

export const useDefaultAppLink = ({
  entryPoint,
}: {
  entryPoint: EntryPoint
}) => {
  const getLink = useGetAppLink({ entryPoint })
  const getApps = usePersonalAppsList()

  const [getGroupAppsRequest] = useLazyGetApiV1GroupsByGroupIdAppsQuery({})
  const getGroupApps = useCallback(
    async (groupId?: string) =>
      groupId ? await getGroupAppsRequest({ groupId }, true).unwrap() : [],
    [getGroupAppsRequest],
  )

  const getDefaultAppLink = useCallback(
    async ({
      defaultApp,
      groupName,
      groupId,
    }: {
      defaultApp?: Application
      groupName?: string
      groupId?: string
    }) => {
      const app =
        defaultApp ??
        (entryPoint === 'USER'
          ? await getApps()
          : await getGroupApps(groupId))[0]

      return getLink(app, groupName)
    },
    [getLink, getApps, entryPoint, getGroupApps],
  )

  return { getDefaultAppLink }
}
